import React from 'react';

import { FeedbackRecognitionTemplateTypes } from 'Shared/constants/types';

import FeedbackFormSection from '../FeedbackFormSection/FeedbackFormSection';
import FeedbackFormFieldContainer from '../FeedbackFormFieldContainer/FeedbackFormFieldContainer';

function FeedbackStrengthsOpportunitiesTemplate() {
  return (
    <FeedbackFormSection templateType={FeedbackRecognitionTemplateTypes.feedbackStrengthsOpportunitiesTemplate}>
      <div className="mb-4">
        <FeedbackFormFieldContainer
          title="Strengths"
          textFieldName="likeThatText"
          videoFieldName="likeThatVideo"
          templateType={FeedbackRecognitionTemplateTypes.feedbackStrengthsOpportunitiesTemplate}
        />
      </div>
      <FeedbackFormFieldContainer
        title="Opportunities for Improvement"
        textFieldName="wishThatText"
        videoFieldName="wishThatVideo"
        templateType={FeedbackRecognitionTemplateTypes.feedbackStrengthsOpportunitiesTemplate}
      />
    </FeedbackFormSection>
  );
}

export default FeedbackStrengthsOpportunitiesTemplate;
